export const API_BASE_URL = "https://ppspring.shop"
